import verConfig, { ver as _ver_ } from "@tt/config";
export const ver = _ver_;
// export const ver = 'A6405';

export const verData = {
  "A6106": {
    tabbar: {
      background: "#fff",
      selectedColor: "#00a6fe",
      color: "#6c7b9d",
      type: "image",
      pages: [
        {
          text: 'newTab.home',
          pagePath: 'goods',
          component: () => import("@/view/goods"),
          iconPath: require("@/assets/tabbar/home.png"),
          selectedIconPath: require("@/assets/tabbar/home_active.png"),
          isSpecial: false,
        },
        {
          text: '晋升',
          pagePath: 'activity',
          component: () => import('@/view/new/activity'),
          iconPath: require("@/assets/tabbar/promo.png"),
          selectedIconPath: require("@/assets/tabbar/promo_active.png"),
          isSpecial: false,
        },
        {
          // text: `${'newTab.order'}`,
          pagePath: '',
          // component: () => import('@/view/bank/recharge'),
          iconPath: require("@/assets/tabbar/deposit.png"),
          selectedIconPath: require("@/assets/tabbar/deposit_active.png"),
          isSpecial: false,
        },
        {
          text: '邀请',
          pagePath: 'inviteFriends',
          component: () => import('@/view/goods/inviteFriends/index'),
          iconPath: require("@/assets/tabbar/invite.png"),
          selectedIconPath: require("@/assets/tabbar/invite_active.png"),
          // isSpecial: true,
        },
        {
          text: '成员',
          pagePath: 'user',
          component: () => import('@/view/user'),
          iconPath: require("@/assets/tabbar/mine.png"),
          selectedIconPath: require("@/assets/tabbar/mine_active.png"),
          isSpecial: false,
        },
      ]
    }
  },
  "A6106_test": {
    tabbar: {
      background: "#fff",
      selectedColor: "#00a6fe",
      color: "#6c7b9d",
      type: "image",
      pages: [
        {
          text: 'newTab.home',
          pagePath: 'goods',
          component: () => import("@/view/goods"),
          iconPath: require("@/assets/tabbar/home.png"),
          selectedIconPath: require("@/assets/tabbar/home_active.png"),
          isSpecial: false,
        },
        {
          text: '晋升',
          pagePath: 'activity',
          component: () => import('@/view/new/activity'),
          iconPath: require("@/assets/tabbar/promo.png"),
          selectedIconPath: require("@/assets/tabbar/promo_active.png"),
          isSpecial: false,
        },
        {
          // text: `${'newTab.order'}`,
          pagePath: '',
          // component: () => import('@/view/bank/recharge'),
          iconPath: require("@/assets/tabbar/deposit.png"),
          selectedIconPath: require("@/assets/tabbar/deposit_active.png"),
          isSpecial: false,
        },
        {
          text: '邀请',
          pagePath: 'inviteFriends',
          component: () => import('@/view/goods/inviteFriends/index'),
          iconPath: require("@/assets/tabbar/invite.png"),
          selectedIconPath: require("@/assets/tabbar/invite_active.png"),
          // isSpecial: true,
        },
        {
          text: '成员',
          pagePath: 'user',
          component: () => import('@/view/user'),
          iconPath: require("@/assets/tabbar/mine.png"),
          selectedIconPath: require("@/assets/tabbar/mine_active.png"),
          isSpecial: false,
        },
      ]
    }
  },
}

export default {
  ...verConfig, ...verData[ver]
};